import type { PartSvgProps } from './types'

export default function BarrelSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 200,
  height = 80
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 200 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Main barrel cylinder — tapers slightly toward muzzle (left) */}
      <path
        d="M 10 34 L 10 46 L 170 50 L 170 30 Z"
        fill={fill} stroke={stroke} strokeWidth="1.5"
      />
      {/* Chamber / breech end (right) — wider */}
      <rect x="170" y="26" width="20" height="28" rx="3"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Gas block bump (~40% from left) */}
      <rect x="76" y="28" width="14" height="24" rx="2"
            fill={fill} stroke={accent} strokeWidth="1.2" />
      {/* Gas tube suggestion — thin line from gas block toward receiver */}
      <line x1="83" y1="28" x2="83" y2="18"
            stroke={accent} strokeWidth="1" strokeDasharray="3 2" />
      {/* Handguard channel line along top */}
      <line x1="12" y1="30" x2="170" y2="30"
            stroke={stroke} strokeWidth="0.8" strokeDasharray="4 3" />
      {/* Crown / muzzle tip */}
      <line x1="10" y1="34" x2="10" y2="46"
            stroke={stroke} strokeWidth="2" />
    </svg>
  )
}
